<template>
  <FaIcon :icon="['fas', 'mobile']" />
</template>
